import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// import { socket } from '../../Socket/page';
import $ from "jquery";
import { Carousel } from "react-responsive-carousel";
import { ToastContainer, toast } from "react-toastify";
import Api from "../../Api/Api";
import useSound from "use-sound";
import Soundpath from "../../sound/songPlay.mp3";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { RingLoader } from "react-spinners";

function Page() {
  const [fademodel, setfademodel] = useState(false);
  const [gamePlayerData, setgamePlayerData] = useState({});
  const [AlertDataDisplay, setAlertDataDisplay] = useState(false);
  const [fademodelliveUser, setfademodelliveUser] = useState(false);
  const [fademodelLevelSelect, setfademodelLevelSelect] = useState(false);
  const [DataInstruction, setDataInstruction] = useState([]);
  const [Leveloption, setLeveloption] = useState([]);
  const [BannerDataUrl,setBannerDataUrl] =useState([])
  const [selectedLevel, setSelectedLevel] = useState();
  const [gameNoAuth, setGameNoAuth] = useState(false);
  const [userData, setUserData] = useState({});
  const [Liveuser, setLiveuser] = useState(0);
  const [loading, setLoading] = useState(false);
  const [play, { stop }] = useSound(Soundpath);
  const [displayMsg, setDisplayMsg] = useState(false);
  const [Msg, setMsg] = useState(false);
  const [operation, setOperation] = useState({});
  const [isGameLoad, setIsGameLoad] = useState(false);
  const [isFreeLoad, setIsFreeLoad] = useState(false);

  const navigate = useNavigate();
  const mongoid = localStorage.getItem("UserIdMongo");
  let options = [];
  // const modelDisplay = () => {
  //     handleShow()
  // }
  // console.log("selected", selectedLevel);
  const [userbalance, setUserbalance] = useState();

  const Auth = localStorage.getItem("Quizetoken");
  // console.log("Auth----->",datauser)
  const clientid = localStorage.getItem("UserIdclient");
  const getBannerdata = () =>
  {
    try{

    }
    catch(error)
    {
         console.log(error)
    }
  }

  const getOperation = async () => {
      try {
        const res = await Api.get(`/admin/operation`);
        setOperation(res.data.result?.operationData[0]);
        // console.log("operation", res.data.result?.operationData[0]);
      } catch (error) {
        console.log("error", error)
      }
    }

  const Getbalance = useCallback(async () => {
    //   const formData= new FormData()
    //   formData.append('userid',1)
    try {
      const response = await Api.get(
        `/user/userWalletBalance?userid=${clientid}`
      );
      // console.log("Dattataat---->payyyy", response.data);
      setUserbalance(response.data.result);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getProfile = async () => {
    const token = localStorage.getItem("Quizetoken");
    if (!token) return; // Don't call API if user is not logged in
    
    let options = [];
    try {
      const res = await Api.get("user/gamesLevel");
      // console.log("Profile===>", res.data.result);
      setUserData(res.data?.result);
      
      if (!res.data.success) {
        // console.log("!res.success");
        options.push({ value: 1, label: `Level 1` });
      } else if (res.data.result == null || !res.data.result) {
        // console.log("!result == null, !res");
        options.push({ value: 1, label: `Level 1` });
      } else {
        const userLevel = res?.data?.result;
        // console.log("res.success", userLevel);

        // options.push({ value: 1, label: `Level 1` });
        userLevel.map(i => options.push({ value: i, label: `Level ${i}` }));

      }
      
      setLeveloption(options);
      // console.log("option", options);
    } catch (error) {
      // console.log("Error profile", error);
        options.push({ value: 1, label: `Level 1` });
      setLeveloption(options);

    }
    // }
  };
  // console.log("option", options);

  
  const WithdrawalBalance = async (level) => {
    // setLoading(true);
    // const formData = new FormData();
    // formData.append("userid", 1);
    try {
      const response = await Api.patch(
        `/user/game-payment`,
        { gameLevel: level },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Quizetoken")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        // console.log("Payment id---->", response.data.result);
        setgamePlayerData(response.data.result);
        localStorage.setItem("GameId", response?.data?.result?.user?.gameId);
        localStorage.setItem("gameLevel", response?.data?.result?.gameLevel);
        return response?.data?.result;
      } else {
        setgamePlayerData("");
        toast(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
        });
      }
      // console.log("Payment id---->", response.data.result);
      // setgamePlayerData(response.data.result);
      // localStorage.setItem("GameId", response.data.result?.user?.gameId);
      // return response.data.result;
    } catch (error) {
      // console.log(error);
      toast(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "error",
      });
    }
    // setLoading(false);
  };
  // console.log("Msg=", Msg);

  const handlepopupCash = async () => {
    // setfademodelLevelSelect(false);
    setIsGameLoad(true);
    // setLoading(true)
    const token = localStorage.getItem("Quizetoken");
    console.log("Level",selectedLevel);
    if (!selectedLevel) {
      // setLoading(false)
      // console.log("msg is true");
      setMsg(true);
    } else {
      // console.log("msg is false");

      if (token) {
        // console.log("cash popup => ", Liveuser);
        // if (userbalance >= operation?.amount_deduct) {
          // WithdrawalBalance();
          // const gameData=gamePlayerData
          // setLoading(false);
          const gameData = await WithdrawalBalance(selectedLevel);
          // console.log("llllll22222=> ", gamePlayerData?.user?.gameId);
           
          if (gameData?.success === true) {
            // setfademodelliveUser(true);
            // setfademodelLevelSelect(true);
             navigate("/gamearea", {
               state: {
                //  GameId: gamePlayerData?.user?.gameId ,
                 Level: selectedLevel,
               },
             });
          } else {
            // WithdrawalBalance();

            setfademodelLevelSelect(false);

            // if (gameData.user.userCurrentLevel === 1) {
            //   navigate("/gamearea", {
            //     state: { popupclose: "popupclose", GameId: userbalance.GameId, gameLevel:gameData.user.userCurrentLevel },
            //   });
            // } else if (gameData.user.userCurrentLevel === 2) {
            //   navigate("/levelone", {
            //     state: { popupclose: "popupclose", GameId: userbalance.GameId,gameLevel:gameData.user.userCurrentLevel },
            //   });
            // } else if (gameData.user.userCurrentLevel === 3) {
            //   navigate("/levelone", {
            //     state: { popupclose: "popupclose", GameId: userbalance.GameId,gameLevel:gameData.user.userCurrentLevel },
            //   });
            // }
          }
        // } else {
        //   toast(
        //     "You don't have insufficient balance. Please recharge your wallet.",
        //     {
        //       position: "top-right",
        //       autoClose: 2000,
        //       hideProgressBar: false,
        //       closeOnClick: true,
        //       pauseOnHover: true,
        //       draggable: true,
        //       progress: undefined,
        //       type: "error",
        //     }
        //   );
        // }
        setfademodel(false);
        // socket.emit("joinRoom", mongoid);
      } else {
        navigate("/login");
        setfademodel(false);
      }
    }
    setIsGameLoad(false)
  };

  const handlepopupFree = async() => {
    setIsFreeLoad(true)
    try {
      if (Auth) {
        //    setfademodel(false)
        const res = await Api.get("/user/free-game-played", {
          headers: {
            Authorization: `Bearer ${Auth}`,
          },
        });
        if(res.data.success){
          // console.log("demo game", res.data.result);
          // console.log("llllll=>sssss", Liveuser);
          navigate("/demogame", { state: "popupclose" });
          setfademodel(false);

        } else{
          toast(res.data.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        }
        
        
        // socket.emit("joinRoom",mongoid)
      } else {
        navigate("/login");
        setfademodel(false);
      }

    } catch (error) {
      // console.log("error", error);
      toast(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "error",
      });
    }
    setIsFreeLoad(false)
    // const token = localStorage.getItem("Quizetoken");
      };

// console.log("Leveloption", Leveloption);
   const DataFatch = async () => {
     try {
       setLoading(true);
       const response = await Api.get("/user/get-all-contents", {
         headers: {
           Authorization: `Bearer ${localStorage.getItem("Quizetoken")}`,
         },
       });

       const bannerresponsive = await Api.get("admin/get-banners");
       setBannerDataUrl(bannerresponsive.data.result);
      //  console.log("brbrbrbrb", bannerresponsive.data.result)
      //  console.log(
      //    "trerm---->",
      //    response.data.result.filter((item) => item.title === "Home Page")
      //  );
       setDataInstruction(response.data.result.filter((item) => item.title === "Home Page")[0]);
       setLoading(false);
     } catch (error) {
       console.log(error);
     }
   };

   useEffect(() => {
     DataFatch();
   }, []);


  useEffect(() => {
    Getbalance();
    getOperation();
  }, []);

  useEffect(() => {
    getProfile();
  }, [Auth]);

  useEffect(()=>{
    if (Leveloption.length === 1 && Leveloption[0].value === 1) {
      setSelectedLevel(1);
      setMsg(false);
    }
  },[Leveloption])

  return (
    <>
      <ToastContainer />
      {/* <div
        className="d-flex justify-content-center"
        style={{ marginTop: "30%", border: "2px solid red" }}
      >
        <RingLoader color="rgb(50 92 213)" size="120" />
      </div> */}
      {loading ? (
        // <></>
        // <div className="preloader align-items-center justify-content-center">
        //    <span className="loader"></span>
        // </div>
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "30%", marginBottom: "20%", height: "20%" }}
        >
          <RingLoader color="rgb(50 92 213)" size="100" />
        </div>
      ) : (
        <section className="banner-section index-one overflow-hidden">
          <div className="shape-area">
            <img
              src="/assets/images/abs-items/planet.png"
              className="shape-1"
              alt="icon"
            />
            {/* <!-- <img src="assets/images/abs-items/console-1.png" className="shape-2" alt="icon"> -->
            <!-- <img src="assets/images/abs-items/console-2.png" className="shape-3" alt="icon"> --> */}
          </div>
          <div className="ellipse-area ellipse-one position-absolute">
            <img
              src="/assets/images/abs-items/ellipse-6.png"
              className="ellipse-1"
              alt="icon"
            />
            <img
              src="/assets/images/abs-items/ellipse-4.png"
              className="ellipse-2"
              alt="icon"
            />
            <img
              src="/assets/images/abs-items/ellipse-5.png"
              className="ellipse-3"
              alt="icon"
            />
          </div>
          <div className="ellipse-area ellipse-two position-absolute">
            <img
              src="/assets/images/abs-items/ellipse-6.png"
              className="ellipse-1"
              alt="icon"
            />
            <img
              src="/assets/images/abs-items/ellipse-3.png"
              className="ellipse-3"
              alt="icon"
            />
            <img
              src="/assets/images/abs-items/ellipse-4.png"
              className="ellipse-4"
              alt="icon"
            />
            <img
              src="/assets/images/abs-items/ellipse-1.png"
              className="ellipse-2"
              alt="icon"
            />
            <img
              src="/assets/images/abs-items/ellipse-5.png"
              className="ellipse-5"
              alt="icon"
            />
          </div>
          <div className="ellipse-area ellipse-three position-absolute">
            <img
              src="/assets/images/abs-items/ellipse-6.png"
              className="ellipse-1"
              alt="icon"
            />
          </div>
          <div className="ellipse-area ellipse-four position-absolute">
            <img
              src="/assets/images/abs-items/ellipse-6.png"
              className="ellipse-1"
              alt="icon"
            />
            <img
              src="/assets/images/abs-items/ellipse-3.png"
              className="ellipse-2"
              alt="icon"
            />
            <img
              src="/assets/images/abs-items/ellipse-2.png"
              className="ellipse-3"
              alt="icon"
            />
          </div>
          <div className="overlay overflow-hidden">
            <div className="banner-content position-relative">
              <div className="container">
                <div className="row justify-content-between justify-content-center align-items-center">
                  <div className="col-md-7">
                    <div className="main-content">
                      <div className="mb-8">
                        {/* <button onClick={handleClick}>Get Microsecond Time</button> */}
                        {/* <h3 className="visible-slowly-bottom sub-title">
                        <span>Enter the Arena, Become the Champion</span>
                      </h3>
                      <span className="display-one">
                        Compete, Conquer,
                        <br />
                        <span className="typed d-inline-block">and Win!</span>
                      </span>
                      <p className="fs-four">
                        Choose a quiz, answer questions, earn points, and win
                        rewards!
                      </p> */}
                        {DataInstruction?.description && (
                          <div
                            style={{ textAlign: "justify" }}
                            dangerouslySetInnerHTML={{
                              __html: DataInstruction?.description,
                            }}
                          ></div>
                        )}
                      </div>
                      <div className="btn-area alt-bg">
                        {/* <a  className="box-style btn-box d-center"  data-bs-toggle="modal" data-bs-target="#exampleModal" > 
                                       <i className="fa-regular fa-circle-play"></i> Play Now
                                    </a> */}

                        <a
                          className="box-style btn-box d-center"
                          onClick={() => {
                            if (!Auth) {
                              // console.log("no auth");
                              setGameNoAuth(true);
                            } else {
                              // console.log("auth");
                              setfademodel(true);
                            }
                          }}
                        >
                          <i className="fa-regular fa-circle-play"></i> Play Now
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className=" col-md-5">
                    <div className="game-carousel ">
                      <div className="slide-area">
                        <div className="top-area d-flex justify-content-end gap-4 mb-5 align-items-end">
                          <img
                            src="/assets/images/icon/top-bottom.png"
                            alt="Image"
                          />
                          <h4 className="mb-1" style={{ color: "#fff" }}>
                            {" "}
                            Games
                          </h4>
                        </div>
                        <SkeletonTheme
                          baseColor="#202020"
                          highlightColor="#444"
                        >
                          <Carousel
                            autoPlay
                            interval={3000}
                            infiniteLoop
                            showThumbs={false}
                            showIndicators={false}
                            showStatus={false}
                            renderArrowPrev={(onClickHandler, hasPrev) =>
                              hasPrev && (
                                <button
                                  className="arafat-next box-style pull-right slick-arrow"
                                  onClick={onClickHandler}
                                  aria-label="Previous"
                                  // style={{ marginTop: "10px" }}
                                >
                                  <i
                                    className="material-symbols-outlined mat-icon"
                                    aria-hidden="true"
                                  >
                                    arrow_right_alt
                                  </i>
                                </button>
                              )
                            }
                            renderArrowNext={(onClickHandler, hasNext) =>
                              hasNext && (
                                <button
                                  className="arafat-prev box-style pull-left slick-arrow"
                                  onClick={onClickHandler}
                                  aria-label="Next"
                                >
                                  <i
                                    className="material-symbols-outlined mat-icon"
                                    aria-hidden="true"
                                  >
                                    arrow_right_alt
                                  </i>
                                </button>
                              )
                            }
                          >
                            {BannerDataUrl.map((values, index) => (
                              <>
                                <div
                                  className="single-slider p-3 p-sm-5"
                                  style={{
                                    height: "310px",
                                  }}
                                >
                                  <div
                                    className="thumb-wrapper"
                                    style={
                                      {
                                        // border: "2px solid  green",
                                        // objectFit: "contain",
                                      }
                                    }
                                  >
                                    <div
                                      className="thumb"
                                      style={{
                                        // border: "2px solid red",
                                        // height: "100%",
                                        // objectFit: "contain",
                                        cursor: values.image_link
                                          ? "pointer"
                                          : "",
                                      }}
                                    >
                                      {values.image_link ? (
                                        <a
                                          onClick={() =>
                                            window.open(
                                              values.image_link,
                                              "_blank",
                                              "noopener,noreferrer"
                                            )
                                          }
                                        >
                                          <img
                                            style={{
                                              height: "250px",
                                              width: "100%",
                                              objectFit: "contain",
                                            }}
                                            src={values.banner_url}
                                            alt="Image"
                                          />
                                        </a>
                                      ) : (
                                        <img
                                          style={{
                                            height: "250px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                          src={values.banner_url}
                                          alt="Image"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ))}

                            {/* <div className="single-slider p-3 p-sm-5">
                            <div className="thumb-wrapper">
                              <div className="thumb">
                                <img
                                  src="/assets/images/quiz1.jpg"
                                  alt="Image"
                                />
                              </div>
                            </div>
                          </div> */}
                          </Carousel>
                        </SkeletonTheme>
                      </div>
                      {/* <button type="button" aria-label="Slide Prev" className="arafat-prev box-style pull-left slick-arrow">
                          <i className="material-symbols-outlined mat-icon" aria-hidden="true">arrow_right_alt</i> 
                          <span className="bg-obj"></span> </button>

                          <button type="button" aria-label="Slide Next" className="arafat-next box-style pull-right slick-arrow" >
                            <i className="material-symbols-outlined mat-icon" aria-hidden="true">arrow_right_alt</i> 
                            <span className="bg-obj"></span> </button>  */}

                      {/* <div className="slide-area">
                                    <div className="top-area d-flex justify-content-end gap-4 mb-5 align-items-end">
                                        <img src="/assets/images/icon/top-bottom.png" alt="Image" />
                                        <h4 className="mb-1" style={{color: '#fff'}}> Games</h4>
                                    </div>
                                    <div className="single-slider p-3 p-sm-5">
                                        <div className="thumb-wrapper">
                                            <div className="thumb">
                                                <img src="/assets/images/quiz2.jpg" alt="Image" />
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                             */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <div
        className="modal fade show"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: fademodel ? "block" : "none", paddingTop: "190px" }}
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ backgroundColor: "#b6b8dc" }}>
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setfademodel(false)}
              ></button>

              <div className="logo poup">
                <Link to="/">
                  <img
                    src="/assets/images/logo-text.png"
                    className="logo-text d-xxl-block  "
                    alt="logo-text"
                  />
                </Link>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <div className="btn-area alt-bg">
                  {/* <h5 style={{ color: "white", textAlign: "center" }}>
                    When you play game for Cash, then we will deduct $2 from
                    your wallet
                  </h5> */}
                  <div className="btn-area alt-bg border-line">
                    {Auth ? (
                      <div className="btn-area alt-bg border-line">
                        <a
                          // onClick={() => setfademodelLevelSelect(true)}
                          onClick={() => {
                            // setDisplayMsg(true);
                            setfademodel(false);
                            if(operation.landingPage)
                              // setLandingPage(true)
                              navigate("/info")
                            else 
                              setfademodelLevelSelect(true);
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginLeft: "155px", marginTop: "12px" }}
                        >
                          {loading ? "Please wait" : "Play for Cash"}
                        </a>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="btn-area alt-bg border-line">
                      <a
                        onClick={() => handlepopupFree()}
                        className="box-style btn-box d-center hoverstyle"
                      >
                        {isFreeLoad ? "Please wait..." : "Play for Free"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* if the user is not logged in then display this message  */}
      {gameNoAuth ? (
        <div
          className="modal fade show"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{
            display: gameNoAuth ? "block" : "none",
            paddingTop: "190px",
          }}
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{ backgroundColor: "#b6b8dc" }}
            >
              <div
                className="modal-body"
                style={{ paddingTop: "8px", paddingBottom: "13px" }}
              >
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setGameNoAuth(false)}
                ></button>

                <div className="logo poup">
                  <Link to="/">
                    <img
                      src="/assets/images/logo-text.png"
                      className="logo-text d-xxl-block  "
                      alt="logo-text"
                    />
                  </Link>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <div className="btn-area alt-bg">
                    <h5 style={{ color: "#20205f", textAlign: "center" }}>
                      To play game, please login
                    </h5>
                    <div className="btn-area alt-bg border-line">
                      <div className="btn-area alt-bg border-line">
                        <a
                          onClick={() => {
                            setGameNoAuth(false);
                            navigate("/login");
                            // setfademodelLevelSelect(true);
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginTop: "2px" }}
                        >
                          {loading ? "Please wait" : "Login"}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* displaying msg when user plays for cash */}
      {displayMsg ? (
        <div
          className="modal fade show"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{
            display: displayMsg ? "block" : "none",
            paddingTop: "190px",
          }}
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{ backgroundColor: "#b6b8dc" }}
            >
              <div className="modal-body">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setDisplayMsg(false)}
                ></button>

                <div className="logo poup">
                  <Link to="/">
                    <img
                      src="/assets/images/logo-text.png"
                      className="logo-text d-xxl-block  "
                      alt="logo-text"
                    />
                  </Link>
                </div>

                <div className="d-flex justify-content-center align-items-center">
                  <div className="btn-area alt-bg">
                    <h5 style={{ color: "#20205f", textAlign: "center" }}>
                      For playing game for Cash, you will be charged $
                      {operation.amount_deduct} for Level-1, from your WSA
                      Available Cash Wallet per game.
                    </h5>
                    <div className="btn-area alt-bg border-line">
                      <div className="btn-area alt-bg border-line">
                        <a
                          onClick={() => {
                            setDisplayMsg(false);
                            handlepopupCash();
                            // setfademodelLevelSelect(true);
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginLeft: "155px", marginTop: "12px" }}
                        >
                          {loading ? "Please wait" : "Continue"}
                        </a>

                        <a
                          onClick={() => {
                            setDisplayMsg(false);
                            // setfademodelLevelSelect(true);
                          }}
                          className="box-style btn-box d-center hoverstyle"
                          // style={{ marginLeft: "155px", marginTop: "12px" }}
                        >
                          Cancel
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* waiting popup user  */}

      <div
        className="modal fade show"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{
          display: fademodelliveUser ? "block" : "none",
          paddingTop: "190px",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ backgroundColor: "#b6b8dc" }}>
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setfademodelliveUser(false)}
              ></button>

              <div className="logo poup">
                <Link to="/">
                  <img
                    src="/assets/images/logo-text.png"
                    className="logo-text d-xxl-block  "
                    alt="logo-text"
                  />
                </Link>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <div className="btn-area alt-bg">
                  {/* {userbalance >= 2 ? } */}
                  <h5 style={{ color: "red", textAlign: "center" }}>
                    Please wait for the other player to finished this level
                  </h5>
                </div>

                {/* <div className="btn-area alt-bg border-line">
                                    <a onClick={()=>handlepopupFree()}  className="box-style btn-box d-center">
                                        Play for Free  
                                    </a>
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* select level popup  */}

      <div
        className="modal fade show"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{
          display: fademodelLevelSelect ? "block" : "none",
          paddingTop: "190px",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ backgroundColor: "#b6b8dc" }}>
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setfademodelLevelSelect(false)}
              ></button>

              <div className="logo poup">
                <Link to="/">
                  <img
                    src="/assets/images/logo-text.png"
                    className="logo-text d-xxl-block  "
                    alt="logo-text"
                  />
                </Link>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <h5>Please select the level you want to play.</h5>
              </div>

              <div className="dropdown-menu1">
                <select
                  className="form-control"
                  value={selectedLevel}
                  onChange={(e) => {
                    // console.log("Slected Level", e.target.value);
                    // if (Leveloption.length === 1 && Leveloption[0].value === 1){
                    //   setSelectedLevel(1);
                    // }else
                      setSelectedLevel(e.target.value);

                    if (e.target.value) setMsg(false);
                  }}
                  // onClick={() => }
                >
                  {/* <option value="">Select Level</option>
                  <option value="1">Level 1</option>
                  <option value="2">Level 2</option>
                  <option value="3">Level 3</option>
                  <option value="4">Level 4</option>
                  <option value="5">Level 5</option>
                  <option value="6">Level 6</option>
                  <option value="7">Level 7</option> */}
                  {Leveloption.length === 1 && Leveloption[0].value === 1 ? (
                    <option value={Leveloption[0].value}>
                      {Leveloption[0].label}
                    </option>
                  ) : (
                    <>
                      <option value="">Select Level</option>
                      {Leveloption.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </>
                  )}
                </select>
                <button
                  onClick={(e) => {
                    // console.log("selected LVL", selectedLevel);
                    if(selectedLevel == 1) {
                      setfademodelLevelSelect(false);
                      setDisplayMsg(true);
                    } else 
                      handlepopupCash();
                    // navigate("/gamearea", {
                    //   state: {
                    //     GameId: gamePlayerData?.user?.gameId,
                    //     Level: selectedLevel,
                    //   },
                    // });
                  }}
                  style={{ marginLeft: "37%" }}
                  disabled={!Msg ? false : true}
                  // href="quiz.html"
                  className="mt-4 box-style btn-box d-center mx-50"
                >
                  {isGameLoad ? "Please Wait..." : "Play Now"}
                </button>
                {Msg ? (
                  <>
                    <p style={{ color: "red" }}>Please select the level</p>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Page;
